import { GridRenderCellParams } from '@mui/x-data-grid';
import React, { useState } from 'react';
import { DeviceWithSticks } from '../../interfaces';
import {
    AssignmentTurnedIn as AssignmentTurnedInIcon,
    Grading as GradingIcon,
    PhotoCamera as PhotoCameraIcon,
    LensBlur as LensBlurIcon,
} from '@mui/icons-material';
import { OscarCheckDialog } from '../OscarCheckDialog';
import { SetupCheckDialog } from '../SetupCheckDialog';
import { Tooltip } from '@mui/material';

export const ChecksCell = (cellValues: GridRenderCellParams) => {
    const [selectedDevice, setSelectedDevice] = useState<DeviceWithSticks | null>(null);
    const [isOscarCheckDialogOpen, setIsOscarCheckDialogOpen] = useState<boolean>(false);
    const [isSetupCheckDialogOpen, setIsSetupCheckDialogOpen] = useState<boolean>(false);

    const v = cellValues.value as Record<string, any> | undefined;

    const handleIsSetupCheckDialogClose = () => {
        setSelectedDevice(null);
        setIsSetupCheckDialogOpen(false);
    };

    const handleIsOscarCheckDialogClose = () => {
        setSelectedDevice(null);
        setIsOscarCheckDialogOpen(false);
    };

    const handleOscarCheckIconClick = () => {
        if (!v) {
            return;
        }
        setSelectedDevice(cellValues.row);
        setIsOscarCheckDialogOpen(true);
    };

    const handleSetupCheckIconClick = () => {
        if (!v) {
            return;
        }
        setSelectedDevice(cellValues.row);
        setIsSetupCheckDialogOpen(true);
    };

    const openCalibrationFileContent = (content?: string) => {
        if (!content) {
            return;
        }

        const blob = new Blob([content], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);

        window.open(url, '_blank');

        setTimeout(() => URL.revokeObjectURL(url), 1000);
    };

    const iconStyle = {
        transition: 'all 0.15s ease',
        marginRight: '5px',
        '&:hover': {
            transform: 'translateY(-3px)',
        },
    };

    return (
        <>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    height: '100%',
                    cursor: v ? 'pointer' : '',
                }}
            >
                {v?.['oscar-check']?.length > 0 && (
                    <Tooltip title="Oscar checks">
                        <AssignmentTurnedInIcon sx={iconStyle} onClick={handleOscarCheckIconClick} />
                    </Tooltip>
                )}

                {v?.['setup-check']?.length > 0 && (
                    <Tooltip title="Setup checks">
                        <GradingIcon sx={iconStyle} onClick={handleSetupCheckIconClick} />
                    </Tooltip>
                )}

                {v?.day && (
                    <Tooltip title="Daytime camera calibration file">
                        <PhotoCameraIcon
                            sx={iconStyle}
                            onClick={() => openCalibrationFileContent(v.day.Content)}
                        />
                    </Tooltip>
                )}

                {v?.thermal && (
                    <Tooltip title="Thermal camera calibration file">
                        <LensBlurIcon
                            sx={iconStyle}
                            onClick={() => openCalibrationFileContent(v.thermal.Content)}
                        />
                    </Tooltip>
                )}
            </div>

            {isOscarCheckDialogOpen && selectedDevice && v && (
                <OscarCheckDialog
                    checks={v['oscar-check']}
                    open={isOscarCheckDialogOpen}
                    onClose={handleIsOscarCheckDialogClose}
                />
            )}

            {isSetupCheckDialogOpen && selectedDevice && v && (
                <SetupCheckDialog
                    checks={v['setup-check']}
                    open={isSetupCheckDialogOpen}
                    onClose={handleIsSetupCheckDialogClose}
                />
            )}
        </>
    );
};
